import React from "react";
import { Link } from "react-router-dom";

const Button = ({ children, linkto, active }) => {
  return (
    <Link to={linkto}>
      <div
        className={`text-center text-[15px] px-6 py-3 rounded-md font-bold
      ${active ? "bg-yellow-50 text-black" : "bg-richblack-800"}
      hover:scale-95 transition-all duration-200 shadow-richblack-500 shadow-sm hover:shadow-none
    `}
      >
        {children}
      </div>
    </Link>
  );
};

export default Button;
